import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class ConfigService {

    /// CONFIGS ///
    listAllConfig(data) {
        return axiosInstance.get(`${config.api.version}/config/${data}/get`)
    }

    getConfig(data, id) {
        return axiosInstance.get(`${config.api.version}/config/${data}/get/${id}`)
    }

    postConfig(data, configs) {
        return axiosInstance.post(`${config.api.version}/config/${data}/`, configs)
    }

    putConfig(data, configs, id) {
        return axiosInstance.put(`${config.api.version}/config/${data}/${id}`, configs)
    }

    deleteConfig(data, id) {
        return axiosInstance.delete(`${config.api.version}/config/${data}/${id}`)
    }

    /// ROLES ///
    listAllRoles(data) {
        return axiosInstance.get(`${config.api.version}/role/${data}/get`)
    }

    listAllPermissions(data) {
        return axiosInstance.get(`${config.api.version}/role/permission/${data}/get`)
    }

    getRole(data, id) {
        return axiosInstance.get(`${config.api.version}/role/${data}/get/${id}`)
    }

    postRole(data, role) {
        return axiosInstance.post(`${config.api.version}/role/${data}/`, role)
    }

    putRole(data, role, id) {
        return axiosInstance.put(`${config.api.version}/role/${data}/${id}`, role)
    }

    deleteRole(data, id) {
        return axiosInstance.put(`${config.api.version}/role/${data}/delete/${id}`)
    }

}